module.exports = __webpack_public_path__ + "media/images/img08-e20d753e8a062cd404a31340980c5eff.png";